import { useMutation, useQuery } from "@tanstack/react-query";
import { DispensingLabelApiService } from "./dispensinglabel.api";

export const useDispensingLabelService = (payload: {
    studyid: number | null;
    subjectno: string | number | null;
    searchText?: string;
    ipcategory?:string | null;
}) => {
    // SELECT ALL DISPENSING LABEL DETAILS
    const SelectAllQuery = useQuery({
        queryKey: ["dispensing-label-SelectAll", payload.studyid, payload.ipcategory, payload.subjectno, payload.searchText],
        queryFn: () => DispensingLabelApiService.selectAll(payload),
        enabled: !!payload.studyid && !!payload.ipcategory && !!payload.subjectno,
    });

    // UPDATE PRINT MUTATION
    const UpdateLabelPrintMutation = useMutation({
        mutationFn: (mutPayload: any) => DispensingLabelApiService.updateLabel(mutPayload),
    });

 
    const InsertDispensingReprintHistoryMutation = useMutation({
    mutationFn: (payload: any) => DispensingLabelApiService.insertReprintHistory(payload),
});

    return {
        SelectAllQuery,
        UpdateLabelPrintMutation,
        InsertDispensingReprintHistoryMutation,
    };
};